import axios from 'axios';

export const getEcimpV4Token = (params:any) => axios.get("/auth/ecimpv4/token",{params:params});